import type { journal as Fr } from '../fr/journal';

/** « journal » in English — typed on the French: a missing sentence does not compile. */
export const journal: typeof Fr = {
  actions: {
    creer: 'Created', modifier: 'Edited', annuler: 'Cancelled', deroger: 'Override',
    cloturer: 'Closed', change: 'Currency exchange', restituer_caution: 'Deposit refunded',
    resilier: 'Terminated', faire_depart: 'Vehicle checked out', faire_retour: 'Vehicle returned',
    demander_correction: 'Correction request', accorder_correction: 'Correction approved',
    refuser_correction: 'Correction refused', signaler: 'Issue reported',
    mettre_liste_noire: 'Blacklisted', retirer_liste_noire: 'Removed from blacklist',
    supprimer: 'Deleted',
  },
  entites: {
    Amende: 'Fine', CaisseSession: 'Cash register session', Caution: 'Deposit', Client: 'Customer',
    Contrat: 'Agreement', Devise: 'Currency', Entretien: 'Maintenance', EtatDesLieux: 'Inspection',
    Facture: 'Invoice', MouvementCaisse: 'Cash movement', Note: 'Note', 'Paramètres': 'Settings',
    Reservation: 'Booking', Sinistre: 'Claim', 'Supplément': 'Extra charge', 'Système': 'System',
    TauxChange: 'Exchange rate', Utilisateur: 'User', 'Véhicule': 'Vehicle',
  },
  titre: 'Audit log',
  sousTitre: (n: number) => `${n} ${n === 1 ? 'entry' : 'entries'} · who did what, and what changed`,
  exporter: 'Export to CSV',
  fichier: 'audit-log.csv',
  inalterable: 'The audit log cannot be altered: no entry can be edited or deleted, by anyone.',
  toutesEntites: 'All entities',
  entrees: 'Entries',
  aucune: 'No entries',
  col: { horodatage: 'Timestamp', utilisateur: 'User', action: 'Action', entite: 'Entity', passe: 'What happened' },
  motif: (m: string) => `reason: ${m}`,
  avant: 'Before',
  apres: 'After',
  appareil: (a: string) => `Device: ${a}`,
  precedent: 'Previous',
  suivant: 'Next',
  page: (p: number, n: number) => `page ${p} / ${n}`,
};
